import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
    :root {
    --color-white: #ffffff;
    --color-light: #7b7b7b;
    --color-blue: #0966c2;
    --color-pearl: #aa9679;
    --color-dark: #231f20;
    --color-gray: #c8c8c8;
    --color-purple: #660746;

    --gray-100: #e1e1e6;
    --gray-300: #c4c4cc;
    --gray-400: #8d8d99;
    --gray-600: #323238;
    --gray-700: #29292e;
    --gray-800: #202024;
    --gray-900: #121214;

  --red-500: #f75a68;

  --green-300: #00b37e;
  --green-500: #00875f;
    }

    @font-face {
        font-family: 'Gilmer';
        src: local('Gilmer'), url(./fonts/Gilmer/gilmer-light.otf) format('truetype');
    }

    html, body, #root {
        min-height: 100vh;
    }
  
    body {
  background-color: var(--gray-900);
  color: var(--gray-300);
  -webkit-font-smoothing: antialiased;
}

    body,input, textarea, button {
        font-family: 'Gilmer';
    }   
    button {
        cursor: pointer;
    }
    [disabled] {
        opacity: 0.6;
        cursor: not-allowed;
    }
    .cursor-pointer { cursor: pointer; }

    .nav-header {
        @media (max-width: 992px) {
            display: flex;
            justify-content: space-between;
        }
    }
`;
